"use strict";
require('/Users/manning/owtb/op-pc-components/node_modules/@alife/operate-keyevent/lib/style.js');
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.AllKeyBind = void 0;

var _keyboardjs = _interopRequireDefault(require("keyboardjs"));

require("./inputFocus");

// @ts-ignore
var Stack = /*#__PURE__*/function () {
  function Stack() {
    this.list = void 0;
    this.list = [];
  }

  var _proto = Stack.prototype;

  _proto.getHeader = function getHeader() {
    return this.list[this.list.length - 1];
  };

  _proto.findIndex = function findIndex(element) {
    var matchIndex = this.list.findIndex(function (item) {
      return item === element;
    });
    return matchIndex;
  };

  _proto.put = function put(element) {
    var matchIndex = this.findIndex(element);

    if (matchIndex > -1) {
      // 先删除
      this.list.splice(matchIndex, 1);
      return;
    }

    this.list.push(element);
  };

  _proto.pop = function pop() {
    this.list.pop();
  };

  _proto.removeItem = function removeItem(element) {
    var matchIndex = this.findIndex(element);
    var matchItem = this.list[matchIndex];

    if (matchIndex > -1) {
      this.list.splice(matchIndex, 1);
    }

    return matchItem;
  };

  _proto.getList = function getList() {
    return this.list;
  };

  return Stack;
}();

var AllKeyBind = /*#__PURE__*/function () {
  function AllKeyBind() {
    this.list = [];
    this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
  }

  var _proto2 = AllKeyBind.prototype;

  _proto2.onDocumentKeyDown = function onDocumentKeyDown(event) {
    this.list.forEach(function (itemFunc) {
      itemFunc instanceof Function && itemFunc(event);
    });
  };

  _proto2.init = function init() {
    document.addEventListener('keydown', this.onDocumentKeyDown, false);
  };

  _proto2.findIndex = function findIndex(element) {
    var matchIndex = this.list.findIndex(function (item) {
      return item === element;
    });
    return matchIndex;
  };

  _proto2.add = function add(handler) {
    if (this.findIndex(handler) > -1) {
      return;
    }

    this.list.push(handler);
  };

  _proto2.bind = function bind(handler) {
    if (!(handler instanceof Function)) {
      return;
    }

    var beforeSize = this.list.length;
    this.add(handler);

    if (beforeSize === 0 && this.list.length === 1) {
      this.init();
    }
  };

  _proto2.unbind = function unbind(handler) {
    if (!(handler instanceof Function)) {
      return;
    }

    var mathIndex = this.findIndex(handler);
    var beforeSize = this.list.length;

    if (mathIndex > -1) {
      this.list.splice(mathIndex, 1);
      return;
    }

    if (beforeSize === 1 && this.list.length === 0) {
      this.destroy();
    }
  };

  _proto2.release = function release() {
    this.list = [];
    this.destroy();
  };

  _proto2.destroy = function destroy() {
    document.removeEventListener('keydown', this.onDocumentKeyDown);
  };

  return AllKeyBind;
}();

exports.AllKeyBind = AllKeyBind;

var Event = /*#__PURE__*/function () {
  function Event() {
    this.mapStack = {};
    this.allBind = new AllKeyBind();

    _keyboardjs["default"].setContext('operate-event' + Date.now());
  }

  var _proto3 = Event.prototype;

  _proto3.midBind = function midBind(key, handler) {
    if (key === 'all') {
      this.allBind.bind(handler);
    } else {
      _keyboardjs["default"].bind(key, handler);
    }
  };

  _proto3.midUnBind = function midUnBind(key, handler) {
    if (key === 'all') {
      this.allBind.unbind(handler);
    } else {
      _keyboardjs["default"].unbind(key, handler);
    }
  };

  _proto3.bind = function bind(key, handler) {
    var lowerKey = key.toLowerCase();

    if (!(handler instanceof Function)) {
      return;
    }

    if (!this.mapStack[lowerKey]) {
      this.mapStack[lowerKey] = new Stack();
    }

    var stack = this.mapStack[lowerKey];
    var oldHeader = stack.getHeader();
    this.midUnBind(lowerKey, oldHeader);
    this.midBind(lowerKey, handler);
    stack.put(handler);
  };

  _proto3.unbind = function unbind(key, handler) {
    var lowerKey = key.toLowerCase();
    var stack = this.mapStack[lowerKey];

    if (!stack) {
      return;
    }

    var header = stack.getHeader();

    if (header === handler) {
      // 删掉了头部，监听事件重制
      this.midUnBind(lowerKey, header);
      stack.pop();
      this.midBind(lowerKey, stack.getHeader());
    } else {
      stack.removeItem(handler);
    }
  };

  _proto3.releaseKey = function releaseKey(key) {
    var lowerKey = key.toLowerCase();
    this.mapStack[lowerKey] = new Stack(); // 重置

    if (lowerKey === 'all') {
      this.allBind.release();
    } else {
      _keyboardjs["default"].unbind(lowerKey);
    }
  };

  return Event;
}();

exports["default"] = Event;